// Společná funkce pro odesílání událostí do datové vrstvy
export function sendEventToDataLayer(eventType, eventData) {
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({ ecommerce: null }); // Vyčištění předchozích ecommerce dat
    window.dataLayer.push({
      event: eventType,
      ecommerce: eventData,
    });
  } else {
    console.error('dataLayer not defined');
  }
}

// Společná funkce pro formátování položek
function formatItems(items) {
  return items.map((item) => ({
    item_id: item.crm_id || item.item_id,
    item_name: item.course?.name || item.item_name,
    quantity: item.attendees ? item.attendees.length : item.quantity || 1,
    price: parseInt(item.price_with_certification || item.price),
    currency: 'CZK',
    item_category: item.category,
    item_brand: item.lecturer,
  }));
}

// Funkce pro trackování zobrazení položky
export function trackViewItem(item) {
  sendEventToDataLayer('view_item', {
    currency: 'CZK',
    value: item.price,
    items: [item],
  });
}

// Funkce pro trackování přidání do košíku
export function trackAddToCart(item, redirectUrl = null) {
  sendEventToDataLayer('add_to_cart', {
    currency: 'CZK',
    value: parseInt(item.price),
    items: [item],
  });

  // Po odeslání dat přesměrování na URL (pokud je poskytnuta)
  if (redirectUrl) {
    setTimeout(() => {
      window.location.href = redirectUrl;
    }, 100); // Nastavení timeoutu, aby mělo odeslání času se zpracovat
  }
}

// Funkce pro trackování nákupu
export function trackPurchase(order) {
  sendEventToDataLayer('purchase', {
    transaction_id: order.transaction_id,
    value: parseInt(order.total),
    tax: order.tax || 0,
    shipping: order.shipping || 0,
    currency: 'CZK',
    items: formatItems(order.items),
  });
}

// Funkce pro trackování zobrazení košíku
export function trackViewCart(order) {
  sendEventToDataLayer('view_cart', {
    currency: 'CZK',
    value: parseInt(order.total_price.noDiscount),
    tax: 0,
    shipping: 0,
    items: formatItems(order.products),
  });
}

// Funkce pro trackování začátku checkoutu
export function trackBeginCheckout(order) {
  sendEventToDataLayer('begin_checkout', {
    currency: 'CZK',
    value: parseInt(order.total_price.noDiscount),
    tax: 0,
    shipping: 0,
    items: formatItems(order.products),
  });
}

// Alpine.js komponenta pro použití na frontend stránkách
export default () => ({
  trackViewItem(item) {
    trackViewItem(item);
  },

  trackAddToCart(item, redirectUrl = null) {
    trackAddToCart(item, redirectUrl);
  },

  trackPurchase(order) {
    trackPurchase(order);
  },

  trackViewCart(order) {
    trackViewCart(order);
  },

  trackBeginCheckout(order) {
    trackBeginCheckout(order);
  },
});
